document.addEventListener('DOMContentLoaded', () => {
  const sizeMap = {
    "35": { AU: "5", US: "5", UK: "3", CM: "22.3" },
    "36": { AU: "5.5", US: "5.5", UK: "3.5", CM: "22.6" },
    "36_2": { AU: "6", US: "6", UK: "4", CM: "22.9" },
    "37": { AU: "6.5", US: "6.5", UK: "4.5", CM: "23.5" },
    "37.5": { AU: "7", US: "7", UK: "5", CM: "23.8" },
    "38": { AU: "7.5", US: "7.5", UK: "5.5", CM: "24.1" },
    "38.5": { AU: "8", US: "8", UK: "6", CM: "24.4" },
    "39": { AU: "8.5", US: "8.5", UK: "6.5", CM: "24.7" },
    "40": { AU: "9", US: "9", UK: "7", CM: "25.3" },
    "41": { AU: "9.5", US: "9.5", UK: "7.5", CM: "25.6" },
    "41_2": { AU: "10", US: "10", UK: "8", CM: "25.9" },
    "42": { AU: "10.5", US: "10.5", UK: "8.5", CM: "26.2" },
    "42_2": { AU: "11", US: "11", UK: "9", CM: "26.5" }
  };

  const updateSizeLabels = (metric, root = document) => {
    const labels = [...root.querySelectorAll('[data-size-label]')];
    const seen = {};

    labels.forEach((label) => {
      const textNode = label.querySelector('[data-size-label-text]');
      const euSize = label.dataset.sizeEu?.trim();

      if (!euSize || !textNode) return;

      seen[euSize] = (seen[euSize] || 0) + 1;

      const key = seen[euSize] === 1 ? euSize : `${euSize}_${seen[euSize]}`;
      const mapped = sizeMap[key];

      if (!mapped || metric === 'EU') {
        textNode.textContent = euSize;
        return;
      }

      textNode.textContent = mapped[metric] || euSize;
    });
  };

  const initSizeMetricToggle = (root = document) => {
    const toggle = root.querySelector('[data-size-metric-toggle]');
    if (!toggle) return;

    const select = toggle.querySelector('[data-size-metric-select]');
    if (!select) return;

    const savedMetric = localStorage.getItem('preferredSizeMetric') || 'EU';

    select.value = savedMetric;

    updateSizeLabels(savedMetric, document);

    select.addEventListener('change', () => {
      const metric = select.value;

      localStorage.setItem('preferredSizeMetric', metric);
      updateSizeLabels(metric, document);
    });
  };

  initSizeMetricToggle();
});